import { api } from "./backend";
import { procesarFiltros } from "./listado";

export function productividadComercial(filtros) {
  const procesados = procesarFiltros(filtros);
  return api.post("productividadComercial/productividad", { filtros: procesados }).then((r) => r.data);
}

export function tablaProductividadComercial(filtros) {
  const procesados = procesarFiltros(filtros);
  return api.post("productividadComercial/tablaProductividadComercial", { filtros: procesados }).then((r) => r.data);
}

export function tablaPronosticoComercial(filtros) {
  const procesados = procesarFiltros(filtros);
  return api.post("productividadComercial/tablaPronosticoComercial", { filtros: procesados }).then((r) => r.data);
}
